/**
 * 一些固定值
 */

module.exports = {
    IMG_COMMON: [
        require('../../assets/warning/ic_faq_1.png'),
        require('../../assets/warning/ic_faq_2.png'),
        require('../../assets/warning/ic_faq_3.png'),
        require('../../assets/warning/ic_faq_4.png'),
        require('../../assets/warning/ic_faq_5.png'),

        require('../../assets/warning/ic_faq_6.png'),
        require('../../assets/warning/ic_faq_7.png'),
        require('../../assets/warning/ic_faq_8.png'),
        require('../../assets/warning/ic_faq_9.png'),
        require('../../assets/warning/img_services_bg.png'),
        
        require('../../assets/doubt.png'),
        require('../../assets/ban.png'),
    ],

    IMG_FAQ_1: [
        require('../../assets/faq_1/icon_1_1.png'),
        require('../../assets/faq_1/icon_1_2.png'),
        require('../../assets/faq_1/icon_1_3.png'),
        require('../../assets/faq_1/icon_1_4.png'),
        require('../../assets/faq_1/icon_1_5.png'),

        require('../../assets/faq_1/icon_1_6.png'),
        require('../../assets/faq_1/icon_1_7.png'),
        require('../../assets/faq_1/icon_1_8.png'),
        require('../../assets/faq_1/icon_1_9.png'),
        require('../../assets/faq_1/icon_1_10.png'),

        require('../../assets/doubt.png'),
        require('../../assets/ban.png'),
    ],

    IMG_FAQ_2: [
        require('../../assets/faq_2/icon_2_1.png'),
        require('../../assets/faq_2/icon_2_2.png'),
        require('../../assets/faq_2/icon_2_3.png'),
        require('../../assets/faq_2/icon_2_4.png'),
        require('../../assets/faq_2/icon_2_5.png'),

        require('../../assets/faq_2/icon_2_6.png'),
        require('../../assets/faq_2/icon_2_7.png'),
        require('../../assets/faq_2/icon_2_8.png'),
        require('../../assets/faq_2/icon_2_9.png'),
        require('../../assets/faq_2/icon_2_10.png'),

        require('../../assets/doubt.png'),
        require('../../assets/ban.png'),
    ],

    IMG_FAQ_3: [
        require('../../assets/faq_3/icon_3_1.png'),
        require('../../assets/faq_3/icon_3_2.png'),
        require('../../assets/faq_3/icon_3_3.png'),
        require('../../assets/faq_3/icon_3_4.png'),
        require('../../assets/faq_3/icon_3_5.png'),

        require('../../assets/faq_3/icon_3_6.png'),
        require('../../assets/faq_3/icon_3_7.png'),
        require('../../assets/faq_3/icon_3_8.png'),
        require('../../assets/faq_3/icon_3_9.png'),
        require('../../assets/faq_3/icon_3_10.png'),

        require('../../assets/doubt.png'),
        require('../../assets/ban.png'),
    ],

    IMG_FAQ_4: [
        require('../../assets/faq_4/icon_4_1.png'),
        require('../../assets/faq_4/icon_4_2.png'),
        require('../../assets/faq_4/icon_4_3.png'),
        require('../../assets/faq_4/icon_4_4.png'),
        require('../../assets/faq_4/icon_4_5.png'),

        require('../../assets/faq_4/icon_4_6.png'),
        require('../../assets/faq_4/icon_4_7.png'),
        require('../../assets/faq_4/icon_4_8.png'),
        require('../../assets/faq_4/icon_4_9.png'),
        require('../../assets/faq_4/icon_4_10.png'),

        require('../../assets/doubt.png'),
        require('../../assets/ban.png'),
    ],

    IMG_FAQ_5: [
        require('../../assets/faq_5/icon_coin_chat.png'),
        require('../../assets/faq_5/icon_get_coin.png'),
        require('../../assets/faq_5/iocn_refund.png'),
        require('../../assets/faq_5/icon_show_self.png'),
        require('../../assets/faq_5/icon_auth_real.png'),

        require('../../assets/faq_5/icon_love_grade.png'),
        require('../../assets/faq_5/icon_contact.png'),
        require('../../assets/faq_5/icon_noble.png'),
        require('../../assets/faq_5/icon_service.png'),
        require('../../assets/faq_5/icon_button_bg.png'),

        require('../../assets/faq_5/icon_love_level.png'),
        require('../../assets/faq_5/icon_violation.png'),
    ],
};